export const ERROR_LOG_SUCCESS_MESSAGE = {
  Resolved: 'Error resolved successfully',
  Unresolved: 'Error unresolved successfully',
  ResolvedMultiple: (value: number) => `${value} errors resolved successfully`,
  UnresolvedMultiple: (value: number) => `${value} errors unresolved successfully`,
};
